module.exports = __webpack_public_path__ + "img/Banner.8e7bbba5.jpg";